import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SurfComponentsCoreModule } from '@surf/surf-components-core';
import { SurfDropDownModule } from '@surf/surf-drop-down';
import { SurfPaginationModule } from '@surf/surf-pagination';
import { SurfTariffSearchComponent } from './surf-tariff-search/surf-tariff-search.component';
import { TariffSearchCriteriaComponent } from './tariff-search-criteria/tariff-search-criteria.component';
import { TariffSearchResultsComponent } from './tariff-search-results/tariff-search-results.component';
import { SurfTypeAheadModule } from '@surf/surf-type-ahead';
import { SurfDatePickerModule } from '@surf/surf-date-picker';
import { SurfCheckboxModule } from '@surf/surf-checkbox';
import { SurfShowCountryPipe } from './pipes/surf-show-country.pipe';
import { SurfRadioButtonModule } from '@surf/surf-radiobutton';

@NgModule({
  declarations: [
    SurfTariffSearchComponent,
    TariffSearchCriteriaComponent,
    TariffSearchResultsComponent,
    SurfShowCountryPipe,
  ],
  imports: [
    CommonModule,
    SurfComponentsCoreModule,
    ScrollingModule,
    SurfPaginationModule,
    SurfDropDownModule,
    SurfTypeAheadModule,
    SurfDatePickerModule,
    SurfCheckboxModule,
    SurfRadioButtonModule,
  ],
  exports: [SurfTariffSearchComponent],
})
export class SurfTariffSearchModule {}
